module.exports = __webpack_public_path__ + "static/media/map1.84bbb9b4.svg";